import type { SITE_MODULATORS_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-modulators-table/site-modulators-table.fr.ts";

export const SITE_MODULATORS_TABLE_ENGLISH_LOCALE = {
  headers: {
    modnum: "# Modnum",
    pilotHwId: "Pilot Hardware Id",
    serialNumber: "Serial number",
    way: "Way",
    csId: "Cs Id",
    hwId: "Hardware Id",
    lastPilotConnectionDatetime: "Last pilot connection date",
    interpretedAcqRate: "Acquisition rate",
    linkedAppliance: "Linked appliance",
    installationDate: "Installation date",
  },
  empty: "No modulator found...",
} satisfies typeof SITE_MODULATORS_TABLE_FRENCH_LOCALE;
